/* eslint-disable eqeqeq */
import axios from "axios";
import { reportsSlice, callTypes } from "./reportsSlice";
import { orderBy } from "lodash";

const API_URL = process.env.REACT_APP_API_URL;
const { actions } = reportsSlice;

export const fetchReports = () => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    return axios
        .get(API_URL + "reports", { params: { _limit: -1, _sort: "published_at:DESC", resolved: "false" } })
        .then((response) => {
            const commentsReport = response.data['comment-report'].map(comment => {
             return { 
                 published_at: comment.published_at, 
                 explanation: comment.explanation, 
                 resolved: comment.resolved, 
                 review_notes: comment.review_notes, 
                 content: comment.comment, 
                 restless_user: comment.restless_user, 
                 created_at: comment.created_at, 
                 id: comment.id + 'Comment', 
                 type: 'Comment', 
                 idReport: comment.id ,
                 reason: comment.reason } 
            })
            
            const postReports = response.data['post-report'].map(post => { 
            return { 
                published_at: post.published_at, 
                explanation: post.explanation, 
                resolved: post.resolved,
                 review_notes: post.review_notes, 
                 content: post.post, 
                 author: post.post.restless_user,
                  restless_user: post.restless_user, 
                  created_at: post.created_at, 
                  id: post.id + 'Post', type: 'Post',
                  idReport: post.id ,
                  reason: post.reason }
                 })
            const articleReport = response.data['article-report'].map(article => { return { published_at: article.published_at, explanation: article.explanation, resolved: article.resolved, review_notes: article.review_notes, content: article.article, restless_user: article.restless_user, created_at: article.created_at, idReport: article.id, id: article.id + 'Article', type: 'Post', reason: article.reason } })
            const allReportsSorted = orderBy([...commentsReport, ...postReports, ...articleReport], 'published_at', 'desc');
            dispatch(actions.reportsFetched({ reportsList: allReportsSorted }));
        })
        .catch((err) => {
            dispatch(actions.catchError({ error: err, callType: callTypes.list }));
        });
};

export const fetchReportsResolved = () => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    return axios
        .get(API_URL + "reports", { params: { _limit: -1, _sort: "published_at:DESC", resolved: "true" } })
        .then((response) => {
            const commentsReport = response.data['comment-report'].map(comment => {
            return { published_at: comment.published_at, explanation: comment.explanation, resolved: comment.resolved, review_notes: comment.review_notes, content: comment.comment, restless_user: comment.restless_user, created_at: comment.created_at, id: comment.id + 'Comment', type: 'Comment',  idReport: comment.id, reason: comment.reason } })
            const postReports = response.data['post-report'].map(post => { 
            return { published_at: post.published_at, explanation: post.explanation, resolved: post.resolved, review_notes: post.review_notes, content: post.post, author: post.post.restless_user, restless_user: post.restless_user, created_at: post.created_at, id: post.id + 'Post', type: 'Post',idReport: post.id , reason: post.reason } })
            const articleReport = response.data['article-report'].map(article => { return { published_at: article.published_at, explanation: article.explanation, resolved: article.resolved, review_notes: article.review_notes, content: article.article, restless_user: article.restless_user, created_at: article.created_at, idReport: article.id, id: article.id + 'Article', type: 'Post', reason: article.reason } })
            const allReportsSorted = orderBy([...commentsReport, ...postReports, ...articleReport], 'published_at', 'desc');
            dispatch(actions.reportsFetched({ reportsList: allReportsSorted }));
        })
        .catch((err) => {
            dispatch(actions.catchError({ error: err, callType: callTypes.list }));
        });
};

export const markContentAsReviewed = (content, reviewNotes) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return axios
        .put(API_URL + `reports`, {
            "id": content.idReport,
            "articleId": content.type == 'Article' ? content.content.id : '',
            "commentId": content.type == 'Comment' ? content.content.id : '',
            "postId": content.type == 'Post' ? content.content.id : '',
            "resolved": true,
            "review_notes": reviewNotes
        })
        .then((response) => {
            dispatch(actions.reportsReviewed(response.data));

        })
        .catch((err) => {
            dispatch(actions.catchError({ error: err, callType: callTypes.list }));
        });
};


export const contentHided = (content, contentId) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.hide }));

    const body = {
        reason: content.reasons,
        comment: content.comments,
        send_pn: content.notifications.includes("Send push"),
        send_email: content.notifications.includes("Send email"),
    };

    return axios
        .put(API_URL + `posts/${contentId}/hide`, body)
        .then((response) => {
            dispatch(actions.contentHided({ contentHided: response.data }));
        })
        .catch((err) => {
            dispatch(actions.catchError({ error: err, callType: callTypes.hide }))
        })
};

export const hideComments = (commentsReport, contentId) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.hide }));
    const body = {
        reason: commentsReport.reasons,
        comment: commentsReport.comments,
        send_pn: commentsReport.notifications.includes("Send push"),
        send_email: commentsReport.notifications.includes("Send email"),
    };
    return axios
        .put(API_URL + `comments/${contentId}/hide`, body)
        .then((response) => {
            dispatch(actions.commentHided({ commentHided: response.data }));
        })
        .catch((err) =>
            {
            dispatch(actions.catchError({ error: err, callType: callTypes.hide }))}
        );
};

export const articlesHide = (articleReport, contentId)  => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.hide }));
    const body = {
        reason: articleReport.reasons,
        comment: articleReport.comments,
        send_pn: articleReport.notifications.includes("Send push"),
        send_email: articleReport.notifications.includes("Send email"),
    };
    return axios
        .put(API_URL + `articles/${contentId}/hide`, body)
        .then((response) => {
            dispatch(actions.articleHided({ articleHided: response.data }));
        })
        .catch((err) =>
            dispatch(actions.catchError({ error: err, callType: callTypes.hide }))
        );
};


export const cleanError = ()  => (dispatch) => {
    dispatch(actions.catchError({ error: null, callType: callTypes.hide }))
    dispatch(actions.commentHided({ commentHided: null}));
    dispatch(actions.articleHided({ articleHided: null }));
    dispatch(actions.contentHided({ contentHided: null }));
};